import { IQuiz } from '../IQuiz'

export const ocpAnti3: IQuiz = {
  name: 'ocp-anti-3',
  question: 'Почему высокое зацепление модулей — это проблема, и его следует избегать?',
  variants: [
    {
      text: 'Отображать изменения требований в коде становится дорого и опасно'
    },
    {
      text: 'Мы теряем возможность заменять объекты другими, схожими с указанными'
    },
    {
      text: 'При изменении требований приходится менять код уже существующих модулей'
    }
  ],
  meta: {
    correctAnswers: [0, 1, 2]
  }
}
